module.exports = __webpack_public_path__ + "img/welfare-storevip.6ab6dc33.png";